import styled from 'styled-components';

export const IconImg = styled.img`
  width: 16px;
  height: 16px;
  filter: invert(79%) sepia(31%) saturate(6761%) hue-rotate(161deg) brightness(88%) contrast(85%);
  display: inline-block !important;
`;
